import router from './router'
import store from './store'
import NProgress from 'nprogress' 
import 'nprogress/nprogress.css' 
import { Form } from 'element-ui'

NProgress.configure({ showSpinner: false }) 

const pathList = ['/','/login','/chooseUser']
router.beforeEach((to, from, next) => {
  NProgress.start()
  const userid = store.getters.userid || (window.localStorage.getItem('store')?JSON.parse(window.localStorage.getItem('store')).user.userid:'')
  const doctype = store.getters.doctype || (window.localStorage.getItem('store')?JSON.parse(window.localStorage.getItem('store')).user.doctype:'')

  if(userid){
      if(doctype){
        if(pathList.indexOf(to.path) !== -1){
          if(from.path === '/infoList'){
            NProgress.done()
          }else{
            next('/infoList')
          }
        }else{
          next()
        }
      }else{
          if(from.path === '/chooseUser'){
            NProgress.done()
          }else{
            next()
        }  
    }
  }else{
    if(to.path === '/login'){
      next()
    }else{
      if(from.path === '/login'){
        NProgress.done()
      }else{
        next('/login')
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
